/**
 * Table of Contents Generator
 * Scans article content for H2 headings and generates a clickable TOC
 */

(function() {
  'use strict';

  const TOC = {
    config: {
      articleSelector: '.article__body',
      headingSelector: 'h2',
      tocContainerSelector: '.article-toc',
      minHeadings: 3,
      smoothScroll: true,
      scrollOffset: 80 // Account for sticky header
    },

    init: function() {
      const article = document.querySelector(this.config.articleSelector);
      const tocContainer = document.querySelector(this.config.tocContainerSelector);

      if (!article || !tocContainer) return;

      const headings = article.querySelectorAll(this.config.headingSelector);

      if (headings.length < this.config.minHeadings) {
        tocContainer.style.display = 'none';
        return;
      }

      this.generateTOC(headings, tocContainer);
      this.initToggle(tocContainer);
      this.initScrollSpy(headings);
    },

    generateTOC: function(headings, container) {
      const list = document.createElement('ol');
      list.className = 'article-toc__list';

      headings.forEach(function(heading, index) {
        // Generate unique ID if not present
        if (!heading.id) {
          heading.id = TOC.slugify(heading.textContent) + '-' + index;
        }

        const listItem = document.createElement('li');
        listItem.className = 'article-toc__item';

        const link = document.createElement('a');
        link.className = 'article-toc__link';
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;

        link.addEventListener('click', function(e) {
          e.preventDefault();
          TOC.scrollToHeading(heading);
        });

        listItem.appendChild(link);
        list.appendChild(listItem);
      });

      const tocList = container.querySelector('.article-toc__content');
      if (tocList) {
        tocList.appendChild(list);
      }

      container.style.display = 'block';
    },

    slugify: function(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .substring(0, 50);
    },

    scrollToHeading: function(heading) {
      const offset = this.config.scrollOffset;
      const targetPosition = heading.getBoundingClientRect().top + window.pageYOffset - offset;

      if (this.config.smoothScroll && 'scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo(0, targetPosition);
      }

      // Update URL hash without jumping
      history.pushState(null, null, '#' + heading.id);
    },

    initToggle: function(container) {
      const toggle = container.querySelector('.article-toc__toggle');
      const content = container.querySelector('.article-toc__content');

      if (!toggle || !content) return;

      toggle.addEventListener('click', function() {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
        content.hidden = isExpanded;
        container.classList.toggle('article-toc--collapsed', isExpanded);
      });
    },

    initScrollSpy: function(headings) {
      if (!('IntersectionObserver' in window)) return;

      const links = document.querySelectorAll('.article-toc__link');
      if (!links.length) return;

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            links.forEach(function(link) {
              link.classList.remove('article-toc__link--active');
              if (link.getAttribute('href') === '#' + entry.target.id) {
                link.classList.add('article-toc__link--active');
              }
            });
          }
        });
      }, {
        rootMargin: '-20% 0% -60% 0%',
        threshold: 0
      });

      headings.forEach(function(heading) {
        observer.observe(heading);
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      TOC.init();
    });
  } else {
    TOC.init();
  }
})();
